


























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TaskItem extends Vue {
  @Prop({ type: String }) label!: string;
  @Prop({ type: String }) status!: string;
  @Prop({ type: String }) icon!: string;
  @Prop({ type: Boolean }) editMode!: boolean;
  @Prop({ type: Boolean }) disabled!: boolean;

  editText = this.label || '';

  abort() {
    this.editText = this.label;
    this.$emit('abort');
  }
}
